export default function($) {
/*#Animatecss right&left*/
  var animate_start = function() {
    var $window = $(window);
    var viewport_top = $window.scrollTop();
    var viewport_height = $window.height();
    var viewport_bottom = viewport_top + viewport_height;

    $('.image-animate').each(function () {
      var top = $(this).offset().top;
      var height = $(this).height();
      var bottom = top + height;

      if ((top >= viewport_top && top < viewport_bottom) || (bottom > viewport_top && bottom <= viewport_bottom) || (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)){
        $(this).css('opacity','1');
        $(this).addClass('animate__animated animate__fadeInRight');
      }
    });
    $('.text-animate').each(function () {
      var top = $(this).offset().top;
      var height = $(this).height();
      var bottom = top + height;

      if ((top >= viewport_top && top < viewport_bottom) || (bottom > viewport_top && bottom <= viewport_bottom) || (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)){
        $(this).css('opacity','1');
        $(this).addClass('animate__animated animate__fadeInLeft');
      }
    });
    /*#Animatecss slideInUp*/
    var $slideInUp = $('#key-number-effect');
    if( $slideInUp[0] ) {
      var top = $slideInUp.offset().top;
      var height = $slideInUp.height();
      var bottom = top + height;

      if ((top >= viewport_top && top < viewport_bottom) || (bottom > viewport_top && bottom <= viewport_bottom) || (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)){
        $('#key-number-effect').css('opacity','1');
        $('#key-number-effect').addClass('animate__animated animate__slideInUp');
      }
    }
  };

  animate_start();
  
  $(window).scroll(function (){
    animate_start();
  })
}
